'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = require('../lib/check');

var _utils = require('../lib/utils');

var _ModelDefinitions = require('./ModelDefinitions');

var _ModelDefinitions2 = _interopRequireDefault(_ModelDefinitions);

var _Model = require('./Model');

var _Model2 = _interopRequireDefault(_Model);

var _ModelCollection = require('./ModelCollection');

var _ModelCollection2 = _interopRequireDefault(_ModelCollection);

var _ModelCollectionProperty = require('./ModelCollectionProperty');

var _ModelCollectionProperty2 = _interopRequireDefault(_ModelCollectionProperty);

var _SchemaTypes = require('../lib/SchemaTypes');

var _SchemaTypes2 = _interopRequireDefault(_SchemaTypes);

var _Filters = require('./Filters');

var _Filters2 = _interopRequireDefault(_Filters);

var _ModelBase = require('./ModelBase');

var _config = require('./config');

var _json = require('./helpers/json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createModelPropertyDescriptor(propertiesObject, schemaProperty) {
    var propertyName = schemaProperty.collection ? schemaProperty.collectionName : schemaProperty.name;
    var propertyDetails = {
        // Actual property descriptor properties
        configurable: false,
        enumerable: true,
        get: function get() {
            return this.dataValues[propertyName];
        }
    };

    // Store available constants for ENUM type properties
    if (schemaProperty.constants) {
        propertyDetails.constants = schemaProperty.constants;
    }

    // Only add a setter for writable properties
    if (schemaProperty.writable) {
        propertyDetails.set = function dynamicPropertySetter(value) {
            // TODO: Objects and Arrays are considered unequal when their data is the same and therefore trigger a dirty
            if (!(0, _check.isObject)(value) && value !== this.dataValues[propertyName] || (0, _check.isObject)(value)) {
                this.dirty = true;
                this[_ModelBase.DIRTY_PROPERTY_LIST].add(propertyName);
                this.dataValues[propertyName] = value;
            }
        };
    }

    if (propertyName) {
        propertiesObject[propertyName] = propertyDetails; // eslint-disable-line no-param-reassign
    }
}

function createPropertiesObject(schemaProperties) {
    var propertiesObject = {};
    var createModelPropertyDescriptorOn = (0, _utils.curry)(createModelPropertyDescriptor, propertiesObject);

    (schemaProperties || []).forEach(createModelPropertyDescriptorOn);

    return propertiesObject;
}

function createValidationSetting(validationObject, schemaProperty) {
    var propertyName = schemaProperty.collection ? schemaProperty.collectionName : schemaProperty.name;
    var validationDetails = {
        persisted: schemaProperty.persisted,
        type: _SchemaTypes2.default.typeLookup(schemaProperty.propertyType),
        required: schemaProperty.required,
        min: schemaProperty.min,
        max: schemaProperty.max,
        owner: schemaProperty.owner,
        unique: schemaProperty.unique,
        writable: schemaProperty.writable,
        ordered: Boolean(schemaProperty.ordered),
        embeddedObject: Boolean(schemaProperty.embeddedObject)
    };

    function getReferenceTypeFrom(property) {
        if (property.href) {
            return property.href.split('/').pop();
        }

        return undefined;
    }

    // Add a referenceType to be able to get a hold of the reference objects model.
    if (validationDetails.type === 'REFERENCE' || validationDetails.type === 'COLLECTION' && schemaProperty.itemPropertyType === 'REFERENCE') {
        validationDetails.referenceType = getReferenceTypeFrom(schemaProperty);
    }

    if (propertyName) {
        validationObject[propertyName] = validationDetails; // eslint-disable-line no-param-reassign
    }
}

function createValidations(schemaProperties) {
    var validationsObject = {};
    var createModelPropertyOn = (0, _utils.curry)(createValidationSetting, validationsObject);

    (schemaProperties || []).forEach(createModelPropertyOn);

    return validationsObject;
}

function shouldBeModelCollectionProperty(model, models) {
    return function shouldBeModelCollectionPropertyIterator(modelProperty) {
        return model && models && model.modelDefinition && model.modelDefinition.modelValidations && model.modelDefinition.modelValidations[modelProperty] && model.modelDefinition.modelValidations[modelProperty].type === 'COLLECTION' && models.hasOwnProperty(model.modelDefinition.modelValidations[modelProperty].referenceType);
    };
}

function isAnUpdate(modelToCheck) {
    return Boolean(modelToCheck.id);
}

var translatableProperties = new WeakMap();

/**
 * @class ModelDefinition
 *
 * @description
 * Definition of a Model. Basically this object contains the meta data related to the Model. Like `name`, `apiEndPoint`, `modelValidation`, etc.
 * It also has methods to create and load Models that are based on this definition. The Data element `ModelDefinition` would be used to create Data Element `Model`s
 *
 * Note: ModelDefinition has a property `api` that is used for the communication with the dhis2 api. The value of this
 * property is an instance of `Api`.
 */

var ModelDefinition = function () {
    function ModelDefinition() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var properties = arguments[1];
        var validations = arguments[2];
        var attributes = arguments[3];
        var authorities = arguments[4];

        _classCallCheck(this, ModelDefinition);

        (0, _check.checkType)(schema.singular, 'string');
        (0, _check.checkType)(schema.plural, 'string', 'Plural');

        (0, _utils.addLockedProperty)(this, 'name', schema.singular);
        (0, _utils.addLockedProperty)(this, 'displayName', schema.displayName);
        (0, _utils.addLockedProperty)(this, 'plural', schema.plural);
        (0, _utils.addLockedProperty)(this, 'isShareable', schema.shareable || false);
        (0, _utils.addLockedProperty)(this, 'isMetaData', schema.metadata || false);
        (0, _utils.addLockedProperty)(this, 'apiEndpoint', schema.apiEndpoint);
        (0, _utils.addLockedProperty)(this, 'javaClass', schema.klass);
        (0, _utils.addLockedProperty)(this, 'identifiableObject', schema && schema.identifiableObject);
        (0, _utils.addLockedProperty)(this, 'modelProperties', properties);
        (0, _utils.addLockedProperty)(this, 'modelValidations', validations);
        (0, _utils.addLockedProperty)(this, 'attributeProperties', attributes);
        (0, _utils.addLockedProperty)(this, 'authorities', authorities);
        (0, _utils.addLockedProperty)(this, 'translatable', schema.translatable || false);

        this.filters = _Filters2.default.getFilters(this);

        translatableProperties.set(this, (schema.properties || []).filter(function (prop) {
            return prop.translationKey;
        }).map(function (_ref) {
            var name = _ref.name,
                translationKey = _ref.translationKey;
            return { name: name, translationKey: translationKey };
        }));

        // TODO: The function getOwnedPropertyJSON should probably not be exposed, perhaps we could have a getJSONForModel(ownedPropertiesOnly=true) method.
        this.getOwnedPropertyJSON = _json.getOwnedPropertyJSON.bind(this);
    }

    _createClass(ModelDefinition, [{
        key: 'filter',
        value: function filter() {
            return this.clone().filters;
        }

        /**
         * @method create
         *
         * @param {Object} [data] Data values that should be loaded into the model.
         *
         * @returns {Model} Returns the newly created model instance.
         *
         * @description
         * Creates a fresh Model instance based on the `ModelDefinition`. If data is passed into the method that
         * data will be loaded into the matching properties of the model.
         *
         * ```js
         * dataElement.create({name: 'ANC', id: 'd2sf33s3ssf'});
         * ```
         */

    }, {
        key: 'create',
        value: function create(data) {
            var model = _Model2.default.create(this);
            var models = _ModelDefinitions2.default.getModelDefinitions();
            var dataValues = data ? Object.assign({}, data) : (0, _config.getDefaultValuesForModelType)(model.modelDefinition.name);

            Object.keys(model).filter(shouldBeModelCollectionProperty(model, models)).forEach(function (modelProperty) {
                var referenceType = model.modelDefinition.modelValidations[modelProperty].referenceType;
                var values = [];

                if (Array.isArray(dataValues[modelProperty])) {
                    values = dataValues[modelProperty].map(function (value) {
                        return models[referenceType].create(value);
                    });
                } else if (dataValues[modelProperty] === true || dataValues[modelProperty] === undefined) {
                    values = dataValues[modelProperty];
                }

                dataValues[modelProperty] = _ModelCollectionProperty2.default.create(model, models[referenceType], modelProperty, values);
                model.dataValues[modelProperty] = dataValues[modelProperty];
            });

            Object.keys(model).filter(function (modelProperty) {
                return !shouldBeModelCollectionProperty(model, models)(modelProperty);
            }).forEach(function (modelProperty) {
                model.dataValues[modelProperty] = dataValues[modelProperty];
            });

            return model;
        }
    }, {
        key: 'clone',
        value: function clone() {
            var ModelDefinitionPrototype = Object.getPrototypeOf(this);
            var priorFilters = this.filters.filters;
            var clonedDefinition = Object.create(ModelDefinitionPrototype);

            clonedDefinition = (0, _utils.copyOwnProperties)(clonedDefinition, this);
            clonedDefinition.filters = _Filters2.default.getFilters(clonedDefinition);
            clonedDefinition.filters.filters = priorFilters.map(function (filter) {
                return filter;
            });

            return clonedDefinition;
        }

        /**
         * @method get
         *
         * @param {String} identifier
         * @param {Object} [queryParams={fields: ':all'}] Query parameters that should be passed to the GET query.
         * @returns {Promise} Resolves with a `Model` instance or an error message.
         *
         * @description
         * Get a `Model` instance from the api loaded with data that relates to `identifier`.
         * This will do an API call and return a Promise that resolves with a `Model` or rejects with the api error message.
         *
         * ```js
         * //Do a get request for the dataElement with given id (d2sf33s3ssf) and print it's name
         * //when that request is complete and the model is loaded.
         * dataElement.get('d2sf33s3ssf')
         *   .then(model => console.log(model.name));
         * ```
         */

    }, {
        key: 'get',
        value: function get(identifier) {
            var _this = this;

            var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { fields: ':all,attributeValues[:all,attribute[id,name,displayName]]' };

            (0, _check.checkDefined)(identifier, 'Identifier');

            if (Array.isArray(identifier)) {
                return this.list({ filter: ['id:in:[' + identifier.join(',') + ']'] });
            }

            // TODO: should throw error if API has not been defined
            return this.api.get([this.apiEndpoint, identifier].join('/'), queryParams).then(function (data) {
                return _this.create(data);
            }).catch(function (response) {
                if (response.message) {
                    return Promise.reject(response.message);
                }

                return Promise.reject(response);
            });
        }

        /**
         * @method list
         *
         * @param {Object} [listParams={fields: ':all'}] Query parameters that should be passed to the GET query.
         * @returns {Promise} ModelCollection collection of models objects of the `ModelDefinition` type.
         *
         * @description
         * Loads a list of models.
         *
         * ```js
         * // Loads a list of models and prints their name.
         * dataElement.list()
         *   .then(modelCollection => {
         *     modelCollection.forEach(model => console.log(model.name));
         *   });
         * ```
         */

    }, {
        key: 'list',
        value: function list() {
            var _this2 = this;

            var listParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var apiEndpoint = listParams.apiEndpoint,
                extraParams = _objectWithoutProperties(listParams, ['apiEndpoint']);

            var params = Object.assign({ fields: ':all' }, extraParams);
            var definedFilters = this.filters.getFilters();

            if (!(0, _check.isDefined)(params.filter)) {
                delete params.filter;
                if (definedFilters.length) {
                    params.filter = definedFilters;
                }
            }

            // If listParams.apiEndpoint exists, send the request there in stead of this.apiEndpoint
            return this.api.get(apiEndpoint || this.apiEndpoint, params).then(function (responseData) {
                return _ModelCollection2.default.create(_this2, responseData[_this2.plural].map(function (data) {
                    return _this2.create(data);
                }), Object.assign(responseData.pager || {}, { query: params }));
            });
        }

        /**
         * @method save
         *
         * @param {Model} model The model that should be saved to the server.
         * @returns {Promise} A promise which resolves when the save was successful
         * or rejects when it failed. The promise will resolve with the data that is
         * returned from the server.
         *
         * @description
         * This method is used by the `Model` instances to save the model when calling `model.save()`.
         *
         * @note {warning} This should generally not be called directly.
         */
        // TODO: check the return status of the save to see if it was actually successful and not ignored

    }, {
        key: 'save',
        value: function save(model) {
            if (isAnUpdate(model)) {
                var jsonPayload = _json.getOwnedPropertyJSON.bind(this)(model);
                var updateUrl = (0, _utils.updateAPIUrlWithBaseUrlVersionNumber)(model.dataValues.href, this.api.baseUrl);

                // Save the existing model
                return this.api.update(updateUrl, jsonPayload, true);
            }

            return this.saveNew(model);
        }
    }, {
        key: 'saveNew',
        value: function saveNew(model) {
            var jsonPayload = _json.getOwnedPropertyJSON.bind(this)(model);

            // Its a new object
            return this.api.post(this.apiEndpoint, jsonPayload);
        }

        /**
         * @method getOwnedPropertyNames
         *
         * @returns {String[]} Returns an array of property names.
         *
         * @description
         * This method returns a list of property names that that are defined
         * as "owner" properties on this schema. This means these properties are used
         * when saving the model to the server.
         *
         * ```js
         * dataElement.getOwnedPropertyNames()
         * ```
         */

    }, {
        key: 'getOwnedPropertyNames',
        value: function getOwnedPropertyNames() {
            var _this3 = this;

            return Object.keys(this.modelValidations).filter(function (propertyName) {
                return _this3.modelValidations[propertyName].owner;
            });
        }

        /**
         * @method delete
         *
         * @returns {Promise} Returns a promise to the deletion operation
         *
         * @description
         * This method is used by the `Model` instances to delete the model when calling `model.delete()`.
         *
         * @note {warning} This should generally not be called directly.
         */

    }, {
        key: 'delete',
        value: function _delete(model) {
            if (model.dataValues.href) {
                return this.api.delete(model.dataValues.href);
            }
            return this.api.delete([model.modelDefinition.apiEndpoint, model.dataValues.id].join('/'));
        }

        /**
         * @method isTranslatable
         *
         * @returns {Boolean} True when the schema can be translated, false otherwise
         */

    }, {
        key: 'isTranslatable',
        value: function isTranslatable() {
            return this.translatable;
        }

        /**
         * @method getTranslatableProperties
         *
         * @returns {String[]} Returns a list of property names on the object that are translatable.
         *
         * @description
         * These properties can be translated using the DHIS2 _database_ translations.
         */

    }, {
        key: 'getTranslatableProperties',
        value: function getTranslatableProperties() {
            return translatableProperties.get(this).map((0, _utils.pick)('name'));
        }

        /**
         * @method getTranslatablePropertiesWithKeys
         *
         * @returns {Object[]} Returns an array with objects that have `name` and `translationKey` properties.
         *
         * @description
         * This method is similar to getTranslatableProperties() but in addition to the property names also returns the
         * `translationKey` that is used to save the translations for the property names.
         */

    }, {
        key: 'getTranslatablePropertiesWithKeys',
        value: function getTranslatablePropertiesWithKeys() {
            return translatableProperties.get(this);
        }

        /**
         * @method createFromSchema
         * @static
         *
         * @param {Object} schema A schema definition received from the web api (/api/schemas)
         * @param {Object[]} attributes A list of attribute objects that describe custom attributes (/api/attributes)
         *
         * @returns {ModelDefinition} Frozen model definition object.
         *
         * @description
         * This method creates a new `ModelDefinition` based on a JSON structure called
         * a schema. A schema represents the structure of a domain model as it is
         * required by DHIS. Since these schemas can not be altered on the server from
         * the modelDefinition is frozen to prevent accidental changes to the definition.
         *
         * ```js
         * ModelDefinition.createFromSchema(schemaDefinition, attributes);
         * ```
         *
         * @note {info} An example of a schema definition can be found on
         * https://apps.dhis2.org/demo/api/schemas/dataElement
         */

    }], [{
        key: 'createFromSchema',
        value: function createFromSchema(schema) {
            var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var ModelDefinitionClass = void 0;
            (0, _check.checkType)(schema, Object, 'Schema');

            if (typeof ModelDefinition.specialClasses[schema.singular] === 'function') {
                ModelDefinitionClass = ModelDefinition.specialClasses[schema.singular];
            } else {
                ModelDefinitionClass = ModelDefinition;
            }

            return Object.freeze(new ModelDefinitionClass(schema, Object.freeze(createPropertiesObject(schema.properties)), Object.freeze(createValidations(schema.properties)), attributes.reduce(function (current, attributeDefinition) {
                current[attributeDefinition.name] = attributeDefinition; // eslint-disable-line no-param-reassign
                return current;
            }, {}), schema.authorities));
        }
    }]);

    return ModelDefinition;
}();

var UserModelDefinition = function (_ModelDefinition) {
    _inherits(UserModelDefinition, _ModelDefinition);

    function UserModelDefinition() {
        _classCallCheck(this, UserModelDefinition);

        return _possibleConstructorReturn(this, (UserModelDefinition.__proto__ || Object.getPrototypeOf(UserModelDefinition)).apply(this, arguments));
    }

    _createClass(UserModelDefinition, [{
        key: 'get',

        // TODO: userCredentials should always be included, no matter what the query params, that is currently not the case
        value: function get(identifier) {
            var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { fields: ':all,userCredentials[:owner]' };

            return _get(UserModelDefinition.prototype.__proto__ || Object.getPrototypeOf(UserModelDefinition.prototype), 'get', this).call(this, identifier, queryParams);
        }
    }]);

    return UserModelDefinition;
}(ModelDefinition);

var DataSetModelDefinition = function (_ModelDefinition2) {
    _inherits(DataSetModelDefinition, _ModelDefinition2);

    function DataSetModelDefinition() {
        _classCallCheck(this, DataSetModelDefinition);

        return _possibleConstructorReturn(this, (DataSetModelDefinition.__proto__ || Object.getPrototypeOf(DataSetModelDefinition)).apply(this, arguments));
    }

    _createClass(DataSetModelDefinition, [{
        key: 'create',
        value: function create() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var hasData = Boolean(Object.keys(data).length);

            // Filter out the compulsoryDataElementOperands structure from the retrieved data
            // This structure does not follow the convention of a typical reference. We can not create a proper
            // ModelCollection for this collection.
            var dataClone = Object.keys(data).filter(function (key) {
                return key !== 'compulsoryDataElementOperands';
            }).reduce(function (obj, key) {
                obj[key] = data[key]; // eslint-disable-line no-param-reassign
                return obj;
            }, {});

            // Create the model using the usual way of creating a model
            // Only pass data when there is data in the object passed to the constructor. This will guarantee
            // that the empty ModelCollections are created properly.
            var model = _get(DataSetModelDefinition.prototype.__proto__ || Object.getPrototypeOf(DataSetModelDefinition.prototype), 'create', this).call(this, hasData ? dataClone : undefined);

            // Set the compulsoryDataElementOperands onto the dataValues so it will be included during the save operations
            model.dataValues.compulsoryDataElementOperands = data.compulsoryDataElementOperands;

            return model;
        }
    }]);

    return DataSetModelDefinition;
}(ModelDefinition);

var OrganisationUnitModelDefinition = function (_ModelDefinition3) {
    _inherits(OrganisationUnitModelDefinition, _ModelDefinition3);

    function OrganisationUnitModelDefinition() {
        _classCallCheck(this, OrganisationUnitModelDefinition);

        return _possibleConstructorReturn(this, (OrganisationUnitModelDefinition.__proto__ || Object.getPrototypeOf(OrganisationUnitModelDefinition)).apply(this, arguments));
    }

    _createClass(OrganisationUnitModelDefinition, [{
        key: 'list',

        // If a 'root' is specified when listing organisation units the results will be limited to the root and its
        // descendants. This is special behavior for the organisation unit API endpoint, which is documented here:
        // https://dhis2.github.io/dhis2-docs/master/en/developer/html/webapi_organisation_units.html
        value: function list() {
            var extraParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var root = extraParams.root,
                params = _objectWithoutProperties(extraParams, ['root']);

            if (extraParams.hasOwnProperty('root') && root) {
                params.apiEndpoint = this.apiEndpoint + '/' + root;
            }

            return _get(OrganisationUnitModelDefinition.prototype.__proto__ || Object.getPrototypeOf(OrganisationUnitModelDefinition.prototype), 'list', this).call(this, params);
        }
    }]);

    return OrganisationUnitModelDefinition;
}(ModelDefinition);

ModelDefinition.specialClasses = {
    user: UserModelDefinition,
    dataSet: DataSetModelDefinition,
    organisationUnit: OrganisationUnitModelDefinition
};

exports.default = ModelDefinition;
//# sourceMappingURL=ModelDefinition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/ModelDefinition.js
// module id = 159
// module chunks = 0